import {
  DataPreview,
  Ghost,
  Paragraph,
  SortableResponsiveTable,
  useSortableTable,
  ResponsiveTableRow,
  Separator,
} from '@fs/zion-ui'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Observable } from '@fs/zion-frontend-friends'
import RowSkeletons from './RowSkeletons'
import { Column1, Column2, Column3 } from './Columns'

function Reloader({ loadNextPage }) {
  useEffect(() => {
    loadNextPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this on Reloader first render
  }, [])
  return null
}

function ResponsiveTableWrapper({ children, oldestToNewest, onSort }) {
  const [t] = useTranslation()
  const sortable = useSortableTable('column3', oldestToNewest, onSort)
  const sortableProps = onSort ? sortable : {}
  return (
    <SortableResponsiveTable
      {...sortableProps}
      totalColumnCount={3}
      gutters="sm"
      separator={<Separator />}
      sortableColumns={onSort ? ['column3'] : []}
      atSizeColumns={{
        lg: {
          labels: [
            t('group-management.name.label'),
            t('group-management.change.label'),
            t('group-management.date.label'),
          ],
          columnWidths: [4, 4, 4],
        },
        default: { labels: [t('group-management.change.label')] },
      }}
    >
      {children}
    </SortableResponsiveTable>
  )
}

export default function Table({
  contributionList,
  loading,
  error,
  contributionsPersons,
  isLastPage = true,
  loadNextPage,
  oldestToNewest,
  onSort,
  removeSort,
}) {
  const [t] = useTranslation()

  return (
    <>
      <DataPreview.Loading loading={loading}>
        <ResponsiveTableWrapper>
          <RowSkeletons count={3} />
        </ResponsiveTableWrapper>
      </DataPreview.Loading>
      <DataPreview.Ready loading={loading}>
        <Observable rootMargin="300px">
          {contributionList && (
            <ResponsiveTableWrapper onSort={!removeSort && onSort} oldestToNewest={oldestToNewest}>
              {contributionList.map((contribution) => (
                <ResponsiveTableRow
                  key={contribution.changeId || contribution.commandId}
                  column1={<Column1 contribution={contribution} contributionsPersons={contributionsPersons} />}
                  column2={<Column2 contribution={contribution} contributionsPersons={contributionsPersons} />}
                  column3={<Column3 contribution={contribution} />}
                />
              ))}

              {!isLastPage && (
                <>
                  <tr>
                    <td aria-label={t('common-ui:loading.ellipsis.label')}>
                      <Ghost heightEstimate={0}>
                        <Reloader loadNextPage={loadNextPage} />
                      </Ghost>
                    </td>
                  </tr>
                  <RowSkeletons count={3} />
                </>
              )}
            </ResponsiveTableWrapper>
          )}
        </Observable>
        {!error && contributionList?.length === 0 && (
          // We only get here if filtering as otherwise there will be at least one change
          <>
            <Separator size="xxs" />
            <Paragraph secondary size="sm">
              {t('group-management.no-changes.warning')}
            </Paragraph>
          </>
        )}
        {error && (
          <>
            <Separator size="xxs" />
            <Paragraph centered secondary>
              {t('group-management.contributions.error')}
            </Paragraph>
          </>
        )}
      </DataPreview.Ready>
    </>
  )
}
